import { getSettingsRootUrl } from './utils';
const getInboxSettingsUrl = () => `${getSettingsRootUrl()}/inboxes`;
export const getInboxAccessUrl = inboxId => `${getInboxSettingsUrl()}/${inboxId}/access`;
export const getInboxEditUrl = inboxId => `${getInboxSettingsUrl()}/edit/${inboxId}`;